import { useState } from 'react'
import { useLogin } from '../hooks/useLogin'
import Loader from './Loader'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const {login, error, isLoading} = useLogin()

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        await login(email, password)
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <form className="login" onSubmit={handleSubmit}>
            <h3>Login</h3>
            <label>Email: </label>
            <input type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
            <label>Password: </label>
            <input type="password" onChange={(e) => setPassword(e.target.value)} value={password} />
            <button type="submit" disabled={isLoading}>Login</button>
            <p>Forgot password? <a href="/request-password-reset">Click Here</a></p>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default Login